/* eslint-disable react/forbid-prop-types */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@cbrebuild/blocks';
import LoadingIcon from '../../../assets/images/svg/loading-icon.svg';
import defaultPage from '../../../assets/images/png/empty-state/map.png';

import {
  fetchXeroBearerToken,
  getPagesArray,
  getFileBlocks,
  getFileImage,
} from '../../../services/lease-abstraction-service';
import './style.scss';

const worker = new Worker(new URL('./imageWorker.js', import.meta.url));

const MAX_LENGTH_OF_CACHE_FOR_EACH_PAGE = 100;

const FileViewer = ({
  pagesData, fileId, pdfPageData, setPdfPageData, annotations, setCurrentHighlightedField,
}) => {
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState([]);
  const [authToken, setAuthToken] = useState('');
  const docId = fileId;
  const [pageInputValue, setPageInputValue] = useState('1');
  const [selectedPage, setSelectedPage] = useState(1);
  const [blocks, setBlocks] = useState([]);
  const [imageWidth, setImageWidth] = useState(0);
  const [canvasWidth, setCanvasWidth] = useState(0);
  const [canvasHeight, setCanvasHeight] = useState(0);
  const [imageOriginalWidth, setImageOriginalWidth] = useState(0);
  const [areaArray, setAreaArray] = useState([]);
  const [searchPages, setSearchPages] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  //
  const [containerStyle, setContainerStyle] = useState({
    position: 'relative',
    width: 0,
  });
  const [imageStyle, setImageStyle] = useState({
    position: 'absolute',
    top: 0,
    left: '0px',
    right: '8px',
    width: 0,
    zIndex: 1,
    userSelect: 'none',
  });
  const [canvasStyle, setCanvasStyle] = useState({
    position: 'absolute',
    top: 0,
    left: '0px',
    width: 0,
    zIndex: 5,
    pointerEvents: 'none',
  });
  const [endDivStyle] = useState({
    width: '0px',
    height: '0px',
    position: 'relative',
    backgroundColor: 'none',
    top: '0px',
  });
  //
  const ANNOTATIONS = {
    annotations: {
      comp_info_base_rent: {},
      comp_info_parking_ratio: {},
      lease_info_floor_number: {
        '0-7-0-11': {
          text: ',',
          group: '5f1b8f0a-98a8-4ee6-be63-85005d72fe24',
          text_confidence: 0.95174754,
          label_confidence: 1,
        },
        '0-7-0-12': {
          text: 'a',
          group: '5f1b8f0a-98a8-4ee6-be63-85005d72fe24',
          text_confidence: 0.98931015,
          label_confidence: 1,
        },
        '0-7-0-13': {
          text: 'portion',
          group: '5f1b8f0a-98a8-4ee6-be63-85005d72fe24',
          text_confidence: 0.945583,
          label_confidence: 1,
        },
        '0-7-0-14': {
          text: 'of',
          group: '5f1b8f0a-98a8-4ee6-be63-85005d72fe24',
          text_confidence: 0.98792374,
          label_confidence: 1,
        },
        '0-7-0-15': {
          text: 'the',
          group: '5f1b8f0a-98a8-4ee6-be63-85005d72fe24',
          text_confidence: 0.9936779,
          label_confidence: 1,
        },
        '0-7-0-16': {
          text: 'ground',
          group: '5f1b8f0a-98a8-4ee6-be63-85005d72fe24',
          text_confidence: 0.9667487,
          label_confidence: 1,
        },
        '0-7-0-17': {
          text: 'floor',
          group: '5f1b8f0a-98a8-4ee6-be63-85005d72fe24',
          text_confidence: 0.9669041,
          label_confidence: 1,
        },
      },
      lease_info_property_name: {
        '0-7-0-39': {
          text: 'located',
          group: '406cda01-546f-4395-9ef7-537e8b50b47f',
          text_confidence: 0.98250306,
          label_confidence: 0.99,
        },
        '0-7-0-40': {
          text: 'at',
          group: '406cda01-546f-4395-9ef7-537e8b50b47f',
          text_confidence: 0.98882926,
          label_confidence: 0.99,
        },
        '0-7-0-41': {
          text: '450',
          group: '406cda01-546f-4395-9ef7-537e8b50b47f',
          text_confidence: 0.99164796,
          label_confidence: 0.99,
        },
        '0-7-0-42': {
          text: 'S.',
          group: '406cda01-546f-4395-9ef7-537e8b50b47f',
          text_confidence: 0.9852256,
          label_confidence: 0.99,
        },
        '0-7-0-43': {
          text: 'County',
          group: '406cda01-546f-4395-9ef7-537e8b50b47f',
          text_confidence: 0.9400233,
          label_confidence: 0.99,
        },
        '0-7-0-44': {
          text: 'Road',
          group: '406cda01-546f-4395-9ef7-537e8b50b47f',
          text_confidence: 0.9772483,
          label_confidence: 0.99,
        },
      },
      lease_info_square_footage: {
        '0-7-0-55': {
          text: '"',
          group: '9424ba34-804c-4964-aa5b-c479aa8f5057',
          text_confidence: 0.74776816,
          label_confidence: 0.98,
        },
        '0-7-0-56': {
          text: ')',
          group: '9424ba34-804c-4964-aa5b-c479aa8f5057',
          text_confidence: 0.9444378,
          label_confidence: 0.98,
        },
        '0-7-0-57': {
          text: ',',
          group: '9424ba34-804c-4964-aa5b-c479aa8f5057',
          text_confidence: 0.95887446,
          label_confidence: 0.98,
        },
        '0-7-0-58': {
          text: 'containing',
          group: '9424ba34-804c-4964-aa5b-c479aa8f5057',
          text_confidence: 0.97181666,
          label_confidence: 0.98,
        },
        '0-7-0-59': {
          text: 'approximately',
          group: '9424ba34-804c-4964-aa5b-c479aa8f5057',
          text_confidence: 0.9941978,
          label_confidence: 0.98,
        },
        '0-7-0-60': {
          text: '1,312',
          group: '9424ba34-804c-4964-aa5b-c479aa8f5057',
          text_confidence: 0.9887547,
          label_confidence: 0.98,
        },
        '0-7-0-61': {
          text: 'square',
          group: '9424ba34-804c-4964-aa5b-c479aa8f5057',
          text_confidence: 0.9927193,
          label_confidence: 0.98,
        },
        '0-7-0-62': {
          text: 'feet',
          group: '9424ba34-804c-4964-aa5b-c479aa8f5057',
          text_confidence: 0.9906972,
          label_confidence: 0.98,
        },
      },
      tenant_buyer_info_address: {
        '19-0-0-0': {
          text: 'To',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9654118,
          label_confidence: 0.99,
        },
        '19-0-0-1': {
          text: 'Tenant',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9927395,
          label_confidence: 0.99,
        },
        '19-0-0-2': {
          text: ':',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.96041167,
          label_confidence: 0.99,
        },
        '19-1-0-0': {
          text: 'FOUNDRAE',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9897835,
          label_confidence: 0.99,
        },
        '19-1-0-1': {
          text: 'RETAIL',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9919197,
          label_confidence: 0.99,
        },
        '19-1-0-2': {
          text: 'PALM',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.99270475,
          label_confidence: 0.99,
        },
        '19-1-0-3': {
          text: 'BEACH',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9776243,
          label_confidence: 0.99,
        },
        '19-1-0-4': {
          text: ',',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9720743,
          label_confidence: 0.99,
        },
        '19-1-0-5': {
          text: 'LLC',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.98764706,
          label_confidence: 0.99,
        },
        '19-1-0-6': {
          text: ',',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.97623956,
          label_confidence: 0.99,
        },
        '19-1-0-7': {
          text: '38',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9910557,
          label_confidence: 0.99,
        },
        '19-1-0-8': {
          text: 'Greene',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9933033,
          label_confidence: 0.99,
        },
        '19-1-0-9': {
          text: 'Street',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9795974,
          label_confidence: 0.99,
        },
        '19-1-1-0': {
          text: 'Floor',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.97810453,
          label_confidence: 0.99,
        },
        '19-1-1-1': {
          text: ',',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9779939,
          label_confidence: 0.99,
        },
        '19-1-1-2': {
          text: 'New',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.99376047,
          label_confidence: 0.99,
        },
        '19-1-1-3': {
          text: 'York',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.98145056,
          label_confidence: 0.99,
        },
        '19-1-1-4': {
          text: ',',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9447765,
          label_confidence: 0.99,
        },
        '19-1-1-5': {
          text: 'NY',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9883378,
          label_confidence: 0.99,
        },
        '19-1-1-6': {
          text: ',',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.98358023,
          label_confidence: 0.99,
        },
        '19-1-1-7': {
          text: '10013',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9921565,
          label_confidence: 0.99,
        },
        '19-1-1-8': {
          text: ',',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9832975,
          label_confidence: 0.99,
        },
        '19-1-1-9': {
          text: 'Attn',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9857883,
          label_confidence: 0.99,
        },
        '19-1-0-10': {
          text: ',',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9225875,
          label_confidence: 0.99,
        },
        '19-1-0-11': {
          text: '2nd',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.98560435,
          label_confidence: 0.99,
        },
        '19-1-1-10': {
          text: ':',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9412277,
          label_confidence: 0.99,
        },
        '19-1-1-11': {
          text: 'Legal',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.99394333,
          label_confidence: 0.99,
        },
        '19-1-1-12': {
          text: 'Notices',
          group: '1596dbce-46dc-495c-96b6-a46672c65ba2',
          text_confidence: 0.9913601,
          label_confidence: 0.99,
        },
      },
      tenant_buyer_info_org_name: {
        '0-1-0-58': {
          text: '"',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.787246,
          label_confidence: 0.99,
        },
        '0-1-0-59': {
          text: ')',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9461297,
          label_confidence: 0.99,
        },
        '0-1-0-60': {
          text: 'and',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9583537,
          label_confidence: 0.99,
        },
        '0-1-0-61': {
          text: 'FOUNDRAE',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.943435,
          label_confidence: 0.99,
        },
        '0-1-0-62': {
          text: 'RETAIL',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9931454,
          label_confidence: 0.99,
        },
        '0-1-0-63': {
          text: 'PALM',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9907333,
          label_confidence: 0.99,
        },
        '0-1-0-64': {
          text: 'BEACH',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.98575574,
          label_confidence: 0.99,
        },
        '0-1-0-65': {
          text: ',',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9638731,
          label_confidence: 0.99,
        },
        '0-1-0-66': {
          text: 'LLC',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9924289,
          label_confidence: 0.99,
        },
        '0-1-0-67': {
          text: ',',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.97949725,
          label_confidence: 0.99,
        },
        '0-1-0-68': {
          text: 'a',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.988627,
          label_confidence: 0.99,
        },
        '0-1-0-69': {
          text: 'Delaware',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9939637,
          label_confidence: 0.99,
        },
        '0-1-0-70': {
          text: 'limited',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9910675,
          label_confidence: 0.99,
        },
        '0-1-0-71': {
          text: 'liability',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.98868287,
          label_confidence: 0.99,
        },
        '0-1-0-72': {
          text: 'company',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.97963274,
          label_confidence: 0.99,
        },
        '0-1-0-73': {
          text: 'authorized',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.99197686,
          label_confidence: 0.99,
        },
        '0-1-0-74': {
          text: 'to',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9884498,
          label_confidence: 0.99,
        },
        '0-1-0-75': {
          text: 'do',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.98285204,
          label_confidence: 0.99,
        },
        '0-1-0-76': {
          text: 'business',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9815886,
          label_confidence: 0.99,
        },
        '0-1-0-77': {
          text: 'in',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9728707,
          label_confidence: 0.99,
        },
        '0-1-0-78': {
          text: 'Florida',
          group: 'f5809ec5-4c70-45e1-a04e-3d6179e9a83a',
          text_confidence: 0.9870733,
          label_confidence: 0.99,
        },
      },
      lease_info_lease_start_date: {
        '0-11-0-130': {
          text: 'then',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9923171,
          label_confidence: 0.95,
        },
        '0-11-0-131': {
          text: 'Tenant',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.98254585,
          label_confidence: 0.95,
        },
        '0-11-0-132': {
          text: 'shall',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.99249655,
          label_confidence: 0.95,
        },
        '0-11-0-133': {
          text: 'be',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9908287,
          label_confidence: 0.95,
        },
        '0-11-0-134': {
          text: 'entitled',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9843577,
          label_confidence: 0.95,
        },
        '0-11-0-135': {
          text: 'to',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9835907,
          label_confidence: 0.95,
        },
        '0-11-0-136': {
          text: 'receive',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.99242973,
          label_confidence: 0.95,
        },
        '0-11-0-137': {
          text: 'a',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9920656,
          label_confidence: 0.95,
        },
        '0-11-0-138': {
          text: 'credit',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9932588,
          label_confidence: 0.95,
        },
        '0-11-0-139': {
          text: 'against',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.99127644,
          label_confidence: 0.95,
        },
        '0-11-0-140': {
          text: 'Base',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.99123675,
          label_confidence: 0.95,
        },
        '0-11-0-141': {
          text: 'Rent',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9873934,
          label_confidence: 0.95,
        },
        '0-11-0-142': {
          text: 'first',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9746913,
          label_confidence: 0.95,
        },
        '0-11-0-143': {
          text: 'coming',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.98788273,
          label_confidence: 0.95,
        },
        '0-11-0-144': {
          text: 'due',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9938629,
          label_confidence: 0.95,
        },
        '0-11-0-145': {
          text: 'under',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.985496,
          label_confidence: 0.95,
        },
        '0-11-0-146': {
          text: 'this',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.98633313,
          label_confidence: 0.95,
        },
        '0-11-0-147': {
          text: 'Lease',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.99145293,
          label_confidence: 0.95,
        },
        '0-11-0-148': {
          text: 'equal',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.99046236,
          label_confidence: 0.95,
        },
        '0-11-0-149': {
          text: 'to',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9591526,
          label_confidence: 0.95,
        },
        '0-11-0-150': {
          text: 'one',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9910649,
          label_confidence: 0.95,
        },
        '0-11-0-151': {
          text: '(',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.97244644,
          label_confidence: 0.95,
        },
        '0-11-0-152': {
          text: '1',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9679389,
          label_confidence: 0.95,
        },
        '0-11-0-153': {
          text: ')',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9774996,
          label_confidence: 0.95,
        },
        '0-11-0-154': {
          text: 'day',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.96827614,
          label_confidence: 0.95,
        },
        '0-11-0-155': {
          text: 'of',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9914536,
          label_confidence: 0.95,
        },
        '0-11-0-156': {
          text: 'Base',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9859999,
          label_confidence: 0.95,
        },
        '0-11-0-157': {
          text: 'Monthly',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9586858,
          label_confidence: 0.95,
        },
        '0-11-0-158': {
          text: 'Rent',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.98960006,
          label_confidence: 0.95,
        },
        '0-11-0-159': {
          text: 'for',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.98886865,
          label_confidence: 0.95,
        },
        '0-11-0-160': {
          text: 'each',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9904171,
          label_confidence: 0.95,
        },
        '0-11-0-161': {
          text: 'day',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.99425554,
          label_confidence: 0.95,
        },
        '0-11-0-162': {
          text: 'that',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.98469543,
          label_confidence: 0.95,
        },
        '0-11-0-163': {
          text: 'the',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9883971,
          label_confidence: 0.95,
        },
        '0-11-0-164': {
          text: 'Commencement',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9922049,
          label_confidence: 0.95,
        },
        '0-11-0-165': {
          text: 'Date',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.97331834,
          label_confidence: 0.95,
        },
        '0-11-0-166': {
          text: 'is',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9806963,
          label_confidence: 0.95,
        },
        '0-11-0-167': {
          text: 'delayed',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9932007,
          label_confidence: 0.95,
        },
        '0-11-0-168': {
          text: 'beyond',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9922582,
          label_confidence: 0.95,
        },
        '0-11-0-169': {
          text: 'June',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.98541486,
          label_confidence: 0.95,
        },
        '0-11-0-170': {
          text: '1',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.92983973,
          label_confidence: 0.95,
        },
        '0-11-0-171': {
          text: ',',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.919745,
          label_confidence: 0.95,
        },
        '0-11-0-172': {
          text: '2025',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9878349,
          label_confidence: 0.95,
        },
        '0-11-0-173': {
          text: 'until',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.98657316,
          label_confidence: 0.95,
        },
        '0-11-0-174': {
          text: 'the',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.98535556,
          label_confidence: 0.95,
        },
        '0-11-0-175': {
          text: 'actual',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.9869049,
          label_confidence: 0.95,
        },
        '0-11-0-176': {
          text: 'Commencement',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.992928,
          label_confidence: 0.95,
        },
        '0-11-0-177': {
          text: 'Date',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.96504325,
          label_confidence: 0.95,
        },
        '0-11-0-178': {
          text: 'occurs',
          group: 'ac74de62-435a-4964-be5e-ab613399e7e7',
          text_confidence: 0.97253644,
          label_confidence: 0.95,
        },
      },
      landlord_seller_info_address: {
        '0-1-0-45': {
          text: 'at',
          group: '7bbba24f-b432-4b14-aa13-acf2dc4a0c8a',
          text_confidence: 0.9924017,
          label_confidence: 0.95,
        },
        '0-1-0-46': {
          text: '700',
          group: '7bbba24f-b432-4b14-aa13-acf2dc4a0c8a',
          text_confidence: 0.99175507,
          label_confidence: 0.95,
        },
        '0-1-0-47': {
          text: 'Castle',
          group: '7bbba24f-b432-4b14-aa13-acf2dc4a0c8a',
          text_confidence: 0.98226047,
          label_confidence: 0.95,
        },
        '0-1-0-48': {
          text: 'Road',
          group: '7bbba24f-b432-4b14-aa13-acf2dc4a0c8a',
          text_confidence: 0.96068364,
          label_confidence: 0.95,
        },
        '0-1-0-49': {
          text: ',',
          group: '7bbba24f-b432-4b14-aa13-acf2dc4a0c8a',
          text_confidence: 0.9497031,
          label_confidence: 0.95,
        },
        '0-1-0-50': {
          text: 'Secaucus',
          group: '7bbba24f-b432-4b14-aa13-acf2dc4a0c8a',
          text_confidence: 0.979229,
          label_confidence: 0.95,
        },
        '0-1-0-51': {
          text: ',',
          group: '7bbba24f-b432-4b14-aa13-acf2dc4a0c8a',
          text_confidence: 0.9671492,
          label_confidence: 0.95,
        },
        '0-1-0-52': {
          text: 'New',
          group: '7bbba24f-b432-4b14-aa13-acf2dc4a0c8a',
          text_confidence: 0.9881621,
          label_confidence: 0.95,
        },
        '0-1-0-53': {
          text: 'Jersey',
          group: '7bbba24f-b432-4b14-aa13-acf2dc4a0c8a',
          text_confidence: 0.99155116,
          label_confidence: 0.95,
        },
        '0-1-0-54': {
          text: '07094',
          group: '7bbba24f-b432-4b14-aa13-acf2dc4a0c8a',
          text_confidence: 0.98788357,
          label_confidence: 0.95,
        },
      },
      landlord_seller_info_org_name: {
        '0-1-0-31': {
          text: 'FERRAGAMO',
          group: 'f2010f1e-a54e-468a-83b0-d715c48c2245',
          text_confidence: 0.99039394,
          label_confidence: 0.99,
        },
        '0-1-0-32': {
          text: 'USA',
          group: 'f2010f1e-a54e-468a-83b0-d715c48c2245',
          text_confidence: 0.9896552,
          label_confidence: 0.99,
        },
        '0-1-0-33': {
          text: ',',
          group: 'f2010f1e-a54e-468a-83b0-d715c48c2245',
          text_confidence: 0.9650662,
          label_confidence: 0.99,
        },
        '0-1-0-34': {
          text: 'INC',
          group: 'f2010f1e-a54e-468a-83b0-d715c48c2245',
          text_confidence: 0.98947054,
          label_confidence: 0.99,
        },
        '0-1-0-35': {
          text: '.',
          group: 'f2010f1e-a54e-468a-83b0-d715c48c2245',
          text_confidence: 0.9785283,
          label_confidence: 0.99,
        },
      },
      lease_info_lease_occupancy_date: {
        '0-11-0-0': {
          text: 'Landlord',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9816634,
          label_confidence: 0.95,
        },
        '0-11-0-1': {
          text: 'anticipates',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9917607,
          label_confidence: 0.95,
        },
        '0-11-0-2': {
          text: 'delivering',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9898257,
          label_confidence: 0.95,
        },
        '0-11-0-3': {
          text: 'possession',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9854962,
          label_confidence: 0.95,
        },
        '0-11-0-4': {
          text: 'of',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9782267,
          label_confidence: 0.95,
        },
        '0-11-0-5': {
          text: 'the',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9898705,
          label_confidence: 0.95,
        },
        '0-11-0-6': {
          text: 'Premises',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.98744184,
          label_confidence: 0.95,
        },
        '0-11-0-7': {
          text: 'to',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9892556,
          label_confidence: 0.95,
        },
        '0-11-0-8': {
          text: 'Tenant',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9763119,
          label_confidence: 0.95,
        },
        '0-11-0-9': {
          text: 'on',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9919331,
          label_confidence: 0.95,
        },
        '0-11-0-10': {
          text: 'or',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9844458,
          label_confidence: 0.95,
        },
        '0-11-0-11': {
          text: 'about',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.98325694,
          label_confidence: 0.95,
        },
        '0-11-0-12': {
          text: 'May',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9928638,
          label_confidence: 0.95,
        },
        '0-11-0-13': {
          text: '1',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9173723,
          label_confidence: 0.95,
        },
        '0-11-0-14': {
          text: ',',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.90929025,
          label_confidence: 0.95,
        },
        '0-11-0-15': {
          text: '2025',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.9882474,
          label_confidence: 0.95,
        },
        '0-10-0-127': {
          text: '.',
          group: 'b415fcab-3e3c-4c31-ad3f-1286bc003998',
          text_confidence: 0.92940414,
          label_confidence: 0.95,
        },
      },
      tenant_buyer_info_contact_email: {
        '19-2-0-0': {
          text: 'with',
          group: 'ae4fee36-f0c5-41e9-8033-9d18ab2ec77a',
          text_confidence: 0.9877275,
          label_confidence: 0.99,
        },
        '19-2-0-1': {
          text: 'a',
          group: 'ae4fee36-f0c5-41e9-8033-9d18ab2ec77a',
          text_confidence: 0.9907187,
          label_confidence: 0.99,
        },
        '19-2-0-2': {
          text: 'courtesy',
          group: 'ae4fee36-f0c5-41e9-8033-9d18ab2ec77a',
          text_confidence: 0.9863695,
          label_confidence: 0.99,
        },
        '19-2-0-3': {
          text: 'email',
          group: 'ae4fee36-f0c5-41e9-8033-9d18ab2ec77a',
          text_confidence: 0.9926097,
          label_confidence: 0.99,
        },
        '19-2-0-4': {
          text: 'to',
          group: 'ae4fee36-f0c5-41e9-8033-9d18ab2ec77a',
          text_confidence: 0.9675062,
          label_confidence: 0.99,
        },
        '19-2-0-5': {
          text: ':',
          group: 'ae4fee36-f0c5-41e9-8033-9d18ab2ec77a',
          text_confidence: 0.944318,
          label_confidence: 0.99,
        },
        '19-2-0-6': {
          text: 'Ruth@foundrae.com',
          group: 'ae4fee36-f0c5-41e9-8033-9d18ab2ec77a',
          text_confidence: 0.97715855,
          label_confidence: 0.99,
        },
      },
      lease_info_lease_expiration_date: {
        '0-10-0-25': {
          text: 'April',
          group: '06f98dc9-a5ef-41a4-a8a3-989dc25e6d9f',
          text_confidence: 0.9894931,
          label_confidence: 0.95,
        },
        '0-10-0-26': {
          text: '30',
          group: '06f98dc9-a5ef-41a4-a8a3-989dc25e6d9f',
          text_confidence: 0.9909649,
          label_confidence: 0.95,
        },
        '0-10-0-27': {
          text: ',',
          group: '06f98dc9-a5ef-41a4-a8a3-989dc25e6d9f',
          text_confidence: 0.9803586,
          label_confidence: 0.95,
        },
        '0-10-0-28': {
          text: '2035',
          group: '06f98dc9-a5ef-41a4-a8a3-989dc25e6d9f',
          text_confidence: 0.98884654,
          label_confidence: 0.95,
        },
      },
      lease_info_property_type_subtype: {
        '4-3-0-0': {
          text: 'A.',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9503315,
          label_confidence: 0.95,
        },
        '4-3-0-1': {
          text: 'Tenant',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9831186,
          label_confidence: 0.95,
        },
        '4-3-0-2': {
          text: 'shall',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9878816,
          label_confidence: 0.95,
        },
        '4-3-0-3': {
          text: 'use',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.98972666,
          label_confidence: 0.95,
        },
        '4-3-0-4': {
          text: 'and',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9872451,
          label_confidence: 0.95,
        },
        '4-3-0-5': {
          text: 'occupy',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9676587,
          label_confidence: 0.95,
        },
        '4-3-0-6': {
          text: 'the',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.992363,
          label_confidence: 0.95,
        },
        '4-3-0-7': {
          text: 'Premises',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9887376,
          label_confidence: 0.95,
        },
        '4-3-0-8': {
          text: 'for',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.98743933,
          label_confidence: 0.95,
        },
        '4-3-0-9': {
          text: 'the',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9870962,
          label_confidence: 0.95,
        },
        '4-3-0-10': {
          text: 'retail',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9902806,
          label_confidence: 0.95,
        },
        '4-3-0-11': {
          text: 'sale',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9901292,
          label_confidence: 0.95,
        },
        '4-3-0-12': {
          text: 'of',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.98027277,
          label_confidence: 0.95,
        },
        '4-3-0-13': {
          text: 'FoundRae',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9704453,
          label_confidence: 0.95,
        },
        '4-3-0-14': {
          text: 'branded',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9810053,
          label_confidence: 0.95,
        },
        '4-3-0-15': {
          text: 'fine',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.9886752,
          label_confidence: 0.95,
        },
        '4-3-0-16': {
          text: 'jewelry',
          group: '7a466e7d-9b3c-46fe-993b-d141d93625ba',
          text_confidence: 0.99222714,
          label_confidence: 0.95,
        },
      },
      comp_info_landlord_represented_by: {
        '22-0-0-10': {
          text: '”',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.6483895,
          label_confidence: 0.95,
        },
        '22-0-0-11': {
          text: ')',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.89570504,
          label_confidence: 0.95,
        },
        '22-0-0-12': {
          text: '.',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9262036,
          label_confidence: 0.95,
        },
        '22-0-0-13': {
          text: 'Landlord',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9807086,
          label_confidence: 0.95,
        },
        '22-0-0-14': {
          text: 'shall',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9886473,
          label_confidence: 0.95,
        },
        '22-0-0-15': {
          text: 'pay',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9899499,
          label_confidence: 0.95,
        },
        '22-0-0-16': {
          text: 'a',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9923482,
          label_confidence: 0.95,
        },
        '22-0-0-17': {
          text: 'commission',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9837655,
          label_confidence: 0.95,
        },
        '22-0-0-18': {
          text: 'to',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.98838586,
          label_confidence: 0.95,
        },
        '22-0-0-19': {
          text: 'Broker',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.98511493,
          label_confidence: 0.95,
        },
        '22-0-0-20': {
          text: 'pursuant',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9846207,
          label_confidence: 0.95,
        },
        '22-0-0-21': {
          text: 'to',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9777799,
          label_confidence: 0.95,
        },
        '22-0-0-22': {
          text: 'a',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.98249507,
          label_confidence: 0.95,
        },
        '22-0-0-23': {
          text: 'separate',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9949864,
          label_confidence: 0.95,
        },
        '22-0-0-24': {
          text: 'agreement',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.99379236,
          label_confidence: 0.95,
        },
        '22-0-0-25': {
          text: 'between',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9900639,
          label_confidence: 0.95,
        },
        '22-0-0-26': {
          text: 'Landlord',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9786315,
          label_confidence: 0.95,
        },
        '22-0-0-27': {
          text: 'and',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.99216896,
          label_confidence: 0.95,
        },
        '22-0-0-28': {
          text: 'Broker',
          group: '7a2b15ff-cfe5-4d31-a0b4-0f491faedb04',
          text_confidence: 0.9817527,
          label_confidence: 0.95,
        },
      },
      landlord_seller_info_contact_email: {
        '19-4-0-2': {
          text: 'emails',
          group: '67585828-534a-4d77-b350-2a6177e12d1e',
          text_confidence: 0.9943294,
          label_confidence: 0.95,
        },
        '19-4-0-3': {
          text: 'to',
          group: '67585828-534a-4d77-b350-2a6177e12d1e',
          text_confidence: 0.98797584,
          label_confidence: 0.95,
        },
        '19-4-0-4': {
          text: ':',
          group: '67585828-534a-4d77-b350-2a6177e12d1e',
          text_confidence: 0.9718948,
          label_confidence: 0.95,
        },
        '19-4-0-5': {
          text: 'todd.stecker@ferragamo.com',
          group: '67585828-534a-4d77-b350-2a6177e12d1e',
          text_confidence: 0.9870665,
          label_confidence: 0.95,
        },
        '19-4-0-6': {
          text: '&',
          group: '67585828-534a-4d77-b350-2a6177e12d1e',
          text_confidence: 0.9681152,
          label_confidence: 0.95,
        },
        '19-4-0-7': {
          text: 'Rachelle',
          group: '67585828-534a-4d77-b350-2a6177e12d1e',
          text_confidence: 0.9695138,
          label_confidence: 0.95,
        },
        '19-4-0-8': {
          text: '.',
          group: '67585828-534a-4d77-b350-2a6177e12d1e',
          text_confidence: 0.97700256,
          label_confidence: 0.95,
        },
        '19-4-0-9': {
          text: 'Vopal@ferragamo.com',
          group: '67585828-534a-4d77-b350-2a6177e12d1e',
          text_confidence: 0.98843616,
          label_confidence: 0.95,
        },
      },
      comp_info_tenant_improvement_detail: {
        '5-9-0-36': {
          text: 'Tenant',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.98571265,
          label_confidence: 0.95,
        },
        '5-9-0-37': {
          text: 'accepts',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.9776388,
          label_confidence: 0.95,
        },
        '5-9-0-38': {
          text: 'the',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.9857684,
          label_confidence: 0.95,
        },
        '5-9-0-39': {
          text: 'Premises',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.98795974,
          label_confidence: 0.95,
        },
        '5-9-0-40': {
          text: 'in',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.9756166,
          label_confidence: 0.95,
        },
        '5-9-0-41': {
          text: 'their',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.9937773,
          label_confidence: 0.95,
        },
        '5-9-0-42': {
          text: 'existing',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.980137,
          label_confidence: 0.95,
        },
        '5-9-0-43': {
          text: '"',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.9836842,
          label_confidence: 0.95,
        },
        '5-9-0-44': {
          text: 'as',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.98969364,
          label_confidence: 0.95,
        },
        '5-9-0-45': {
          text: 'is',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.99270743,
          label_confidence: 0.95,
        },
        '5-9-0-46': {
          text: '"',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.98211694,
          label_confidence: 0.95,
        },
        '5-9-0-47': {
          text: 'condition',
          group: '1c54a58a-9029-4c87-af04-78437d9aef9f',
          text_confidence: 0.95876765,
          label_confidence: 0.95,
        },
      },
      tenant_buyer_info_contact_first_name: {
        '28-12-0-1': {
          text: ':',
          group: '21de12fa-b8af-498a-aef4-a85c21791329',
          text_confidence: 0.9594005,
          label_confidence: 0.95,
        },
        '28-13-0-0': {
          text: 'Ruth',
          group: '21de12fa-b8af-498a-aef4-a85c21791329',
          text_confidence: 0.9668903,
          label_confidence: 0.95,
        },
        '28-13-0-1': {
          text: 'Sommers',
          group: '21de12fa-b8af-498a-aef4-a85c21791329',
          text_confidence: 0.9507829,
          label_confidence: 0.95,
        },
        '28-13-1-0': {
          text: 'Its',
          group: '21de12fa-b8af-498a-aef4-a85c21791329',
          text_confidence: 0.97153795,
          label_confidence: 0.95,
        },
        '28-13-1-1': {
          text: ':',
          group: '21de12fa-b8af-498a-aef4-a85c21791329',
          text_confidence: 0.9456857,
          label_confidence: 0.95,
        },
        '28-13-1-2': {
          text: 'CEO',
          group: '21de12fa-b8af-498a-aef4-a85c21791329',
          text_confidence: 0.9415161,
          label_confidence: 0.95,
        },
      },
      landlord_seller_info_contact_first_name: {
        '28-3-2-3': {
          text: 'L',
          group: '340ecd29-26e9-412b-aa5f-3b3ac1e7ff78',
          text_confidence: 0.47781545,
          label_confidence: 0.99,
        },
        '28-4-0-0': {
          text: 'Todd',
          group: '340ecd29-26e9-412b-aa5f-3b3ac1e7ff78',
          text_confidence: 0.98890615,
          label_confidence: 0.99,
        },
        '28-4-0-1': {
          text: 'Stecker',
          group: '340ecd29-26e9-412b-aa5f-3b3ac1e7ff78',
          text_confidence: 0.99356604,
          label_confidence: 0.99,
        },
      },
    },
  };
  const [annotationObj, setAnnotationsObj] = useState(ANNOTATIONS);
  const [highlightedField, setHilightedField] = useState('N/A');
  //
  const canvasRef = useRef(null);
  const docContainerRef = useRef(null);
  //
  const clearCanvas = () => {
    setHilightedField('N/A');
    setCurrentHighlightedField('N/A');
    const canvas = canvasRef.current;
    if (canvas) {
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvasWidth, canvasHeight);
    }
  };
  //
  const clearSearch = () => {
    clearCanvas();
  };
  //
  useEffect(() => () => {
    setLoading(false);
  }, []);
  //
  useEffect(() => {
    if (Object.keys(annotations.annotations).length > 0) {
      setAnnotationsObj(annotations);
    }
  }, [annotations]);
  //
  useEffect(() => {
    if (searchText === '') {
      clearSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);
  //
  const searchWord = (searchedText) => {
    const searchedPages = [];
    pages.forEach((element, index) => {
      if (
        pages[index].text.toLowerCase().includes(searchedText.toLowerCase())
      ) {
        searchedPages.push(index + 1);
      }
    });
    return searchedPages;
  };
  //
  const drawRect = (coords, fillColor, lineWidth, strokeColor) => {
    const [left, top, right, bot] = coords;
    const canvas = canvasRef.current;
    if (canvas) {
      const context = canvas.getContext('2d');
      context.beginPath();
      context.fillStyle = fillColor;
      context.strokeStyle = strokeColor;
      context.lineWidth = lineWidth;
      context.lineJoin = 'round';
      context.strokeRect(left, top, right - left, bot - top);
      context.fillRect(left, top, right - left, bot - top);
      context.closePath();
    }
  };
  //
  const scale = (widths) => {
    if (Object.keys(widths).length > 0) {
      return widths.imageWidth &&
        widths.imageOriginalWidth &&
        widths.imageOriginalWidth > 0
        ? widths.imageWidth / widths.imageOriginalWidth
        : 1;
    }
    return imageWidth && imageOriginalWidth && imageOriginalWidth > 0
      ? imageWidth / imageOriginalWidth
      : 1;
  };
  //
  const scaleCoords = (coords, widths) => {
    const xScale = scale(widths);
    return coords.map(coord => coord * xScale);
  };
  //
  const convertVerticiesToCoords = verticies => [
    verticies[0].x,
    verticies[0].y,
    verticies[2].x,
    verticies[2].y,
  ];
  //
  const highlightSearch = (block) => {
    const coords = scaleCoords(convertVerticiesToCoords(block.vertices), {
      imageWidth,
      imageOriginalWidth,
    });
    if (coords.length > 0) {
      drawRect(
        coords,
        'rgba(255, 199, 0, 0.3)',
        1,
        'rgba(255, 199, 0, 0.3)',
      );
    }
  };
  //
  const setBlocksArr = (lastWord, searchString, words, wndex, blocksArr) => {
    if (lastWord.includes(searchString[searchString.length - 1])) {
      let blocksArrParm = [...blocksArr];
      for (let i = 0; i < searchString.length; i++) {
        const eachWord = words[wndex + i].text.toLowerCase();
        if (eachWord.includes(searchString[i])) {
          blocksArrParm.push(words[wndex + i]);
        } else {
          blocksArrParm = [];
          break;
        }
      }
      if (blocksArrParm.length > 1) {
        blocksArrParm = [...new Set(blocksArrParm)];
        blocksArrParm.forEach((blockVal) => {
          highlightSearch(blockVal);
        });
      }
    }
  };
  //
  const getWordDetails = (
    searchString,
    currentWord,
    words,
    word,
    wndex,
    blocksArr,
  ) => {
    if (searchString.length === 1 && currentWord.includes(searchString[0])) {
      highlightSearch(word);
    }
    if (searchString.length > 1 && currentWord.includes(searchString[0])) {
      const length = searchString.length - 1;
      if (words[wndex + length]) {
        const lastWord = words[wndex + length].text.toLowerCase();
        setBlocksArr(lastWord, searchString, words, wndex, blocksArr);
      }
    }
  };
  //
  const onSearchPdf = (searchString, searchBlocks = blocks) => {
    const splitSearchString = searchString.toLowerCase().split(' ');
    let blocksArr = [];
    searchBlocks.forEach((block) => {
      if (block.children) {
        const paragraphs = block.children;
        paragraphs.forEach((paragraph) => {
          if (paragraph.children) {
            const words = paragraph.children;
            words.forEach((word, wndex) => {
              blocksArr = [];
              const currentWord = word.text.toLowerCase();
              getWordDetails(
                splitSearchString,
                currentWord,
                words,
                word,
                wndex,
                blocksArr,
              );
            });
          } else {
            console.log('** missing children in page hierarchy');
          }
        });
      }
    });
  };
  //
  const setInitialHeight = () => {
    setTimeout(() => {
      const wrapper = document.getElementsByClassName('fv-image-container')[0];
      if (wrapper) {
        setCanvasHeight(wrapper.height);
      }
    }, 20);
  };
  //
  const changeImageWidth = (changedImageWidth) => {
    const changedImageStyle = { ...imageStyle };
    changedImageStyle.width = `${changedImageWidth}px`;
    setImageStyle(changedImageStyle);

    const changedContainerStyle = { ...containerStyle };
    changedContainerStyle.width = `${changedImageWidth}px`;
    setContainerStyle(changedContainerStyle);

    const changedCanvasStyle = { ...canvasStyle };
    changedCanvasStyle.width = `${changedImageWidth}px`;
    setCanvasStyle(changedCanvasStyle);
    setCanvasWidth(changedImageWidth);
  };
  //
  const setInitialWidth = (pagesArray = pages) => {
    const element = docContainerRef.current || document.getElementsByClassName('fv-doc-container')[0];
    const currentPage = pagesArray[selectedPage - 1];

    if (!element || !element.getBoundingClientRect || !currentPage) {
      return null;
    }

    const nextImageWidth = Math.max(element.getBoundingClientRect().width - 16, 0);

    if (imageWidth !== nextImageWidth) {
      setImageWidth(nextImageWidth);
      setImageOriginalWidth(currentPage.width);
    }

    changeImageWidth(nextImageWidth);
    return {
      imageWidth: nextImageWidth,
      imageOriginalWidth: currentPage.width,
    };
  };
  //
  const getImageAreaBlocks = (
    block,
    position,
    constructedAreaBlocks,
    widths,
  ) => {
    const scaled = scaleCoords(
      convertVerticiesToCoords(block.vertices),
      widths,
    );
    const currentPosition = [...position];
    let newLabel = block.label;
    if (block.label === undefined || block.label === '') {
      newLabel = 'O';
    }
    const extendedBlock = {
      ...block,
      currentPosition,
      scaled,
      newLabel,
    };
    constructedAreaBlocks.push({
      label: newLabel,
      coords: scaled.join(','),
      extendedBlock,
    });
  };
  //
  const constructImageMap = (currentBlocks, widths) => {
    const constructedAreaBlocks = [];
    if (currentBlocks) {
      currentBlocks.map((block, i) => {
        if (block.children) {
          const paragraphs = block.children;
          return paragraphs.map((paragraph, j) => {
            if (paragraph.children) {
              const words = paragraph.children;
              return words.map((word, k) => {
                const wordParam = word;
                if (block.labels) {
                  wordParam.label = block.labels;
                }
                getImageAreaBlocks(
                  wordParam,
                  [i, j, k],
                  constructedAreaBlocks,
                  widths,
                );
              });
            }
            console.log('** missing children in page hierarchy');
          });
        }
      });
      setAreaArray(constructedAreaBlocks);
    }
  };
  //
  const getPageBlocks = (blockData, pageSelected, pagesArray = pages) => {
    if (blockData) {
      if (blockData.blocks) {
        setBlocks(blockData.blocks);
        const editedPages = pagesArray;
        editedPages[pageSelected].blocks = blocks;
        setPages(editedPages);
        const widths = setInitialWidth(editedPages);
        setInitialHeight();
        constructImageMap(blockData.blocks, widths);
      }
    }
  };
  //
  const makePageBlocksAPICall = async (pageNumber, token) => {
    const newPageBlocks = await getFileBlocks(
      fileId,
      pagesData[pageNumber].page_url,
      {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'text/plain',
      },
    );
    return newPageBlocks;
  };
  //
  const makePageImageAPICall = async (pageNumber, token) => {
    const pageImage = await getFileImage(
      fileId,
      pagesData[pageNumber].image_url,
      {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'image/jpeg',
        Accept: 'image/jpeg',
      },
    );
    return pageImage;
  };

  const promisifyRequest = request =>
    new Promise((resolve, reject) => {
      request.oncomplete = () => resolve(request.result);
      request.onsuccess = () => resolve(request.result);
      request.onabort = () => reject(request.error);
      request.onerror = () => reject(request.error);
    });

  const createStore = (dbName, storeName) => {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = () => request.result.createObjectStore(storeName);
    const dbp = promisifyRequest(request);

    return (txMode, callback) =>
      dbp.then(db =>
        callback(db.transaction(storeName, txMode).objectStore(storeName)));
  };
  const defaultGetStore = () =>
    createStore('file-data-store', 'fileExtractionData');
  //
  const setDBValue = (key, value, customStore = defaultGetStore()) =>
    customStore('readwrite', (store) => {
      store.put(value, key);
      return promisifyRequest(store.transaction);
    });
  //
  const getDBValue = (key, customStore = defaultGetStore()) =>
    customStore('readonly', store => promisifyRequest(store.get(key)));

  // const base64ToBlob = (base64, mimeType) => {
  //   const byteCharacters = atob(base64);
  //   const byteNumbers = new Array(byteCharacters.length);
  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }
  //   const byteArray = new Uint8Array(byteNumbers);
  //   return new Blob([byteArray], { type: mimeType });
  // };
  //
  // const blobToBase64 = blob =>
  //   new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onloadend = () => resolve(reader.result.split(',')[1]);
  //     reader.onerror = reject;
  //     reader.readAsDataURL(blob);
  //   });
  //
  const handlePageImageStorage = async (pageNumber, token) => {
    // Retrieve 'pageImage' from local storage
    // const pageImage = JSON.parse(localStorage.getItem('fileExtractionData'));
    const pageImage = await getDBValue('fileExtractionData');
    if (!pageImage) {
      // If 'pageImage' is not present, create it
      const newPageBlocks = await makePageBlocksAPICall(pageNumber, token);
      const newPageImage = await makePageImageAPICall(pageNumber, token);
      // const base24ImageData = await blobToBase64(newPageImage);
      const firstStorageData = {
        [pageNumber]: [
          {
            documentId: fileId,
            pageBlocks: newPageBlocks,
            pageImage: newPageImage,
          },
        ],
      };
      // localStorage.setItem(
      //   'fileExtractionData',
      //   JSON.stringify(firstStorageData),
      // );
      await setDBValue('fileExtractionData', firstStorageData);
      return {
        documentId: fileId,
        pageBlocks: newPageBlocks,
        pageImage: newPageImage,
      };
    }
    // pageImage = JSON.parse(pageImage);

    // Check if the pageNumber is not present in the keys
    if (!Object.prototype.hasOwnProperty.call(pageImage, pageNumber)) {
      // If pageNumber is not present, create a new property
      const newPageBlocks = await makePageBlocksAPICall(pageNumber, token);
      const newPageImage = await makePageImageAPICall(pageNumber, token);
      // const base24ImageData = await blobToBase64(newPageImage);
      pageImage[pageNumber] = [
        {
          documentId: fileId,
          pageBlocks: newPageBlocks,
          pageImage: newPageImage,
        },
      ];
      // localStorage.setItem('fileExtractionData', JSON.stringify(pageImage));
      await setDBValue('fileExtractionData', pageImage);
      return {
        documentId: fileId,
        pageBlocks: newPageBlocks,
        pageImage: newPageImage,
      };
    }
    // If pageNumber is present, check for existing documentId
    const pageEntries = pageImage[pageNumber];
    const existingEntry = pageEntries.find(entry => entry.documentId === docId);

    if (existingEntry) {
      // If documentId is found, shift this entry to the end and return the complete object
      const index = pageEntries.indexOf(existingEntry);
      if (index > -1) {
        pageEntries.splice(index, 1); // Remove the existing entry
      }
      pageEntries.push(existingEntry); // Add it to the end
      await setDBValue('fileExtractionData', pageImage);
      return existingEntry;
    }
    // If documentId is not found, check if the pages length is less than MAX_LENGTH_OF_CACHE_FOR_EACH_PAGE
    // If less, then add the new entry
    // Else, remove the first entry and add the new one
    const newPageBlocks = await makePageBlocksAPICall(pageNumber, token);
    const newPageImage = await makePageImageAPICall(pageNumber, token);
    // const base24ImageData = await blobToBase64(newPageImage);
    if (pageEntries.length >= MAX_LENGTH_OF_CACHE_FOR_EACH_PAGE) {
      pageEntries.shift(); // Remove the first entry
    }
    pageEntries.push({
      documentId: fileId,
      pageBlocks: newPageBlocks,
      pageImage: newPageImage,
    });
    // localStorage.setItem('fileExtractionData', JSON.stringify(pageImage));
    await setDBValue('fileExtractionData', pageImage);
    return {
      documentId: fileId,
      pageBlocks: newPageBlocks,
      pageImage: newPageImage,
    };
  };
  const getPageDetails = async (
    pageNumber,
    token = authToken,
    pagesArray = pages,
  ) => {
    if (pagesData && Object.keys(pagesData).length > 0) {
      try {
        setLoading(true);
        // const pageBlocks = await getFileBlocks(
        //   fileId,
        //   pagesData[pageNumber].page_url,
        //   {
        //     Authorization: `Bearer ${token}`,
        //     'Content-Type': 'text/plain',
        //   },
        // );
        const { pageBlocks, pageImage } = await handlePageImageStorage(
          pageNumber,
          token,
        );
        // const pageImage = await getFileImage(
        //   fileId,
        //   pagesData[pageNumber].image_url,
        //   {
        //     Authorization: `Bearer ${token}`,
        //     'Content-Type': 'image/jpeg',
        //     Accept: 'image/jpeg',
        //   },
        // );
        setLoading(false);
        setErrorMessage('');
        const img = document.getElementById('fv-image-container');
        worker.postMessage(pageImage);
        worker.onmessage = (e) => {
          const readableUrl = URL.createObjectURL(e.data);
          setTimeout(() => {
            img.setAttribute('src', readableUrl);
          }, 50);

          img.onload = () => {
            URL.revokeObjectURL(img.src);
            // add a condition to check if the img.source contains the text blob or not
            if (img.src.includes('blob')) {
              if (
                pagesArray[pageNumber - 1] &&
                pagesArray[pageNumber - 1].name
              ) {
                getPageBlocks(pageBlocks, pageNumber - 1, pagesArray);
              }
            }
          };
          img.onerror = () => {
            console.log('HIGH-RES IMAGE ERROR');
            setErrorMessage('Unable to get the page information, try another page.');
            throw new Error('Unable to load image');
          };
        };
        return pageBlocks.blocks;
      } catch (error) {
        setLoading(false);
        setErrorMessage('Unable to get the file information, please try again later.');
        console.log('Unable to fetch page data');
      }
    }
  };
  //
  // const getPageDetails = async (currentpage) => {
  //   if (pages[currentpage - 1] && pages[currentpage - 1].name) {
  //     setImage(`/public/assets/images/page-${currentpage}.jpg`);
  //     const auxUrlValue = pages[currentpage - 1].aux_url;
  //     const response = await fetch(`/public/${auxUrlValue}`);
  //     const jsonResp = await response.json();
  //     getPageBlocks(jsonResp, currentpage - 1);
  //     return jsonResp.blocks;
  //   }
  // };
  //
  const onPageChange = useCallback(async (pageNumber) => {
    if (pageNumber && pageNumber > 0 && pageNumber <= pages.length) {
      setSelectedPage(pageNumber);
      document
        .getElementById(`fv-page-number-button-${pageNumber.toString()}`)
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
      setPageInputValue(pageNumber.toString());
      if (pageNumber <= pages.length) {
        clearCanvas();
        const searchBlocks = await getPageDetails(pageNumber);
        if (searchText.length > 0) {
          onSearchPdf(searchText, searchBlocks);
        }
        if (pdfPageData.annotationField !== 'N/A') {
          getHighlitedBlocks(searchBlocks, pageNumber);
        }
      }
    }
  });
  //
  const changeSearchPage = (count) => {
    const currentSearchPageIndex = searchPages.findIndex(searchPage => searchPage.toString() === selectedPage.toString());
    if (
      currentSearchPageIndex + count >= 0 &&
      currentSearchPageIndex + count < searchPages.length
    ) {
      onPageChange(searchPages[currentSearchPageIndex + count]);
    }
  };
  //
  const getBlockIdByPosition = (position, pageNumber = selectedPage) => {
    let blockId = (pageNumber - 1).toString();
    for (const i of position) {
      if (i === -1) {
        break;
      }
      blockId = `${blockId}-${i.toString()}`;
    }
    return blockId;
  };
  //
  // Lessee-Broker-Name
  // Parking-Ratio-1000-Sqft
  // Lessor-Contact-Organization
  const getAnnotationsByBlockId = (
    blockId,
    fieldLabel = 'Lessee-Broker-Name',
  ) => {
    let annotations = [];
    if (annotationObj && 'annotations' in annotationObj) {
      Object.keys(annotationObj.annotations).forEach((label) => {
        if (label !== pdfPageData.annotationField) {
          return;
        }
        annotations = isAnnotations(blockId, label, annotations);
      });
    }
    return annotations;
  };
  //
  const isAnnotations = (blockId, label, annotations) => {
    if (blockId in annotationObj.annotations[label]) {
      const annotation = annotationObj.annotations[label][blockId];
      annotations.push({
        group: 'group' in annotation ? annotation.group : '',
        label,
        label_confidence:
          'label_confidence' in annotation ? annotation.label_confidence : 1.0,
        text: 'text' in annotation ? annotation.text : '',
        text_confidence:
          'text_confidence' in annotation ? annotation.text_confidence : 1.0,
        status: 'status' in annotation ? annotation.status : 'argmax',
      });
    }
    return annotations;
  };
  //
  const isYellow = (annotations, coords) => {
    if (highlightedField !== pdfPageData.annotationField) {
      setHilightedField(pdfPageData.annotationField);
      setCurrentHighlightedField(pdfPageData.annotationField);
    }
    drawRect(coords, 'rgba(250,250,0,0.3)', 1, 'rgba(250,250,0,0.3)');
  };
  //
  const onHighlightArea = (block, position, pageNumber = selectedPage) => {
    const coords = scaleCoords(convertVerticiesToCoords(block.vertices), {
      imageWidth,
      imageOriginalWidth,
    });
    const blockId = getBlockIdByPosition(position, pageNumber);
    const annotations = getAnnotationsByBlockId(blockId);
    if (annotations.length > 0) {
      // highlight if labeled
      isYellow(annotations, coords);
    }
    return null;
  };
  //
  const getHighlitedBlocks = (blocks, pageNumber = selectedPage) => {
    if (blocks && blocks.length > 0) {
      blocks.map((block, index) => {
        if (block.children && !block.labels) {
          const paragraphs = block.children;
          return paragraphs.map((paragraph, jndex) => {
            if (paragraph.children) {
              const words = paragraph.children;
              return words.map((word, kndex) => {
                onHighlightArea(word, [index, jndex, kndex], pageNumber);
              });
            }
            console.log('** missing children in page hierarchy');
          });
        }
      });
    }
  };
  //
  const onSearchEnter = useCallback(async (searchValue) => {
    const searchedPages = searchWord(searchValue);
    setSearchPages(searchedPages);
    if (searchedPages.length > 0) {
      setSelectedPage(parseInt(searchedPages[0], 10));
      setPageInputValue(searchedPages[0]);
      if (parseInt(searchedPages[0], 10) <= pages.length) {
        clearCanvas();
        const searchBlocks = await getPageDetails(parseInt(searchedPages[0], 10));
        onSearchPdf(searchValue, searchBlocks);
      }
    }
  });
  //
  useEffect(() => {
    const searchInput = document.getElementById('search-input');
    const pageNumberInput = document.getElementById('page-number-input');
    const handleSearchEvent = (event) => {
      if (event.key === 'Enter') {
        onSearchEnter(event.target.value, blocks);
      }
    };
    const handlePageNumberEvent = (event) => {
      if (event.key === 'Enter') {
        const enteredPageNumber = event.target.value;
        if (/^[1-9][0-9]*$/.test(enteredPageNumber)) {
          onPageChange(parseInt(enteredPageNumber, 10));
        }
      }
    };
    searchInput.addEventListener('keyup', handleSearchEvent);
    pageNumberInput.addEventListener('keyup', handlePageNumberEvent);
    return () => {
      searchInput.removeEventListener('keyup', handleSearchEvent);
      pageNumberInput.removeEventListener('keyup', handlePageNumberEvent);
    };
  }, [onSearchEnter, onPageChange, blocks]);
  //
  const onAreaClick = (block, event) => {
    event.preventDefault();
    navigator.clipboard.writeText(block.text);
  };
  //
  const getfilePages = async () => {
    try {
      setLoading(true);
      const { result } = await fetchXeroBearerToken();
      setAuthToken(result.access_token);
      const customHeaders = {
        Authorization: `Bearer ${result.access_token}`,
        'Content-Type': 'application/json',
      };
      const pagesArray = await getPagesArray(fileId, customHeaders);
      setLoading(false);
      setPages(pagesArray.pages);
      getPageDetails(1, result.access_token, pagesArray.pages);
      setErrorMessage('');
    } catch (error) {
      setLoading(false);
      setErrorMessage('Unable to get the file information, please try again later.');
      console.log('Unable to get file pages');
    }
  };
  //

  useEffect(() => {
    if (!docContainerRef.current || blocks.length === 0 || !pages[selectedPage - 1]) return undefined;

    const syncViewerLayout = () => {
      const widths = setInitialWidth();
      if (!widths) return;

      setInitialHeight();
      constructImageMap(blocks, widths);

      window.requestAnimationFrame(() => {
        clearCanvas();
        if (searchText.length > 0) {
          onSearchPdf(searchText, blocks);
        }
        if (pdfPageData.annotationField !== 'N/A') {
          getHighlitedBlocks(blocks, selectedPage);
        }
      });
    };

    syncViewerLayout();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', syncViewerLayout);
      return () => window.removeEventListener('resize', syncViewerLayout);
    }

    const resizeObserver = new ResizeObserver(() => {
      syncViewerLayout();
    });

    resizeObserver.observe(docContainerRef.current);

    return () => resizeObserver.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocks, pages, selectedPage, searchText, pdfPageData.annotationField]);

  useEffect(() => {
    // Update the selected page when the page number changes so that the correct page is displayed when clicked from the Lease abstraction fields
    if (pdfPageData.pageNumber !== -1 && selectedPage !== pdfPageData.pageNumber) {
      onPageChange(pdfPageData.pageNumber);
    } else if (pdfPageData.annotationField !== 'N/A') {
      clearCanvas();
      getHighlitedBlocks(blocks, selectedPage);
    } else {
      clearCanvas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdfPageData]);
  //
  useEffect(() => {
    // Update the page number when the selected page changes so that the parent component has the correct page number
    setPdfPageData({
      pageNumber: selectedPage,
      annotationField: 'N/A',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPage]);
  //
  useEffect(() => {
    getfilePages();
    // getPageDetails(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //
  return (
    <div className="fv-container">
      <div className="fv-header">
        <div className="fv-header-container">
          <section className="fv-header__left">
            <div className="fv-page-number-editor">
              <input
                type="text"
                className="fv-page-number-input"
                id="page-number-input"
                value={pageInputValue}
                onChange={(e) => {
                  setPageInputValue(e.target.value);
                }}
                disabled={loading || errorMessage}
              />
              <span>of {pages.length}</span>
            </div>
            <div className="fv-pagination-container">
              <div
                onClick={() => {
                  if (selectedPage > 1 && !loading) {
                    onPageChange(selectedPage - 1);
                  }
                }}
                className="fv-pagination-button"
                title="
                Previous page"
              >
                {'<'}
              </div>
              <div className="fv-page-numbers-container">
                {Array.from({ length: pages.length }, (_, i) => i + 1).map(pageNumber => (
                  <div
                    key={pageNumber.toString()}
                    id={`fv-page-number-button-${pageNumber.toString()}`}
                    className={`fv-page-number ${
                        selectedPage === pageNumber
                          ? 'fv-page-number--selected'
                          : ''
                      }`}
                    onClick={() => {
                        if (!loading) {
                          onPageChange(pageNumber);
                        }
                      }}
                  >
                    {pageNumber}
                  </div>
                  ))}
              </div>
              <div
                onClick={() => {
                  if (selectedPage < pages.length && !loading) {
                    onPageChange(selectedPage + 1);
                  }
                }}
                className="fv-pagination-button"
                title="Next page"
              >
                {'>'}
              </div>
            </div>
          </section>
          <section className="fv-header__right">
            <div className="fv-divider" />
            <div className="fv-search-container">
              <div className="fv-search-input-container">
                <input
                  type="text"
                  className="fv-search-input"
                  id="search-input"
                  placeholder="Search"
                  value={searchText}
                  onChange={(event) => {
                    setSearchText(event.target.value);
                  }}
                  disabled={loading || errorMessage}
                />
                <IconButton
                  className="fv-search-clear"
                  iconName="close"
                  onClick={() => {
                    if (!loading) {
                      setSearchText('');
                      clearSearch();
                      setSearchPages([]);
                    }
                  }}
                  aria-label="close"
                  variant="basic"
                  title="Clear search"
                />
              </div>
              <div
                className="fv-search-button"
                onClick={() => {
                  if (searchText.length > 1 && !loading) {
                    onSearchEnter(searchText);
                  }
                }}
                title="Search"
              >
                Go
              </div>
              <div
                onClick={() => {
                  if (!loading) {
                    changeSearchPage(-1);
                  }
                }}
                className="fv-search-page-button"
                title="Prev search page"
              >
                {'<'}
              </div>
              <div
                onClick={() => {
                  if (!loading) {
                    changeSearchPage(1);
                  }
                }}
                className="fv-search-page-button"
                title="Next search page"
              >
                {'>'}
              </div>
            </div>
            {/* <div className="fv-divider" />
            <div className="fv-zoom-container">
              <div disabled className="fv-search-page-button">
                +
              </div>
              <div disabled className="fv-search-page-button">
                -
              </div>
            </div> */}
          </section>
        </div>
      </div>
      <div className="fv-doc-container" ref={docContainerRef}>
        <div id="endDiv" style={endDivStyle} />
        {loading ? (
          <div className="fv-loading-icon">
            <div className="fv-spinner">
              <img alt="Loading" src={LoadingIcon} />
            </div>
          </div>
        ) : (
          <>
            {errorMessage.length > 0 ? (
              <div className="fv-error-message">{errorMessage}</div>
            ) : (
              <div className="fv-pdf-container" style={containerStyle}>
                <img
                  src={defaultPage}
                  className="fv-image-container"
                  id="fv-image-container"
                  style={imageStyle}
                  alt="Document Loading"
                  useMap={`#${docId}`}
                />
                <canvas
                  style={canvasStyle}
                  width={canvasWidth}
                  height={canvasHeight}
                  id="canvas"
                  ref={canvasRef}
                />
                <map name={docId} id={docId}>
                  {areaArray.map(area => (
                    <area
                      key={area.coords}
                      alt={area.label}
                      shape="rect"
                      coords={area.coords}
                      onClick={event =>
                        onAreaClick(area.extendedBlock, event)
                      }
                    />
                  ))}
                </map>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

FileViewer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  annotations: PropTypes.object.isRequired,
  pagesData: PropTypes.object.isRequired,
  fileId: PropTypes.string.isRequired,
  pdfPageData: PropTypes.object.isRequired,
  setPdfPageData: PropTypes.func.isRequired,
  setCurrentHighlightedField: PropTypes.func.isRequired,
};

FileViewer.defaultProps = {};

export default FileViewer;
